export const ADMISSION_WELCOME_ROUTE = "/workflow/welcome";
